import React from 'react';

function Divider({children, className}) {
    return (
        <div className={"divider " + ((typeof className !== "undefined") ? className : '')}>
            {children}
        </div>
    )
}

export default React.memo(Divider)